import { ProgressCircle } from './progress-circle';
import { AssessmentItem } from './skills-assessment';
import { useTranslation } from 'react-i18next';

export function AssessmentCard({
  title,
  description,
  score,
  explanation,
  improvement,
}: AssessmentItem) {
  const { t } = useTranslation();
  
  const getColor = (score: number) => {
    if (score <= 4) return '#FF9A42';
    else if (score <= 6) return '#1C7AEB';
    return '#089E71';
  };
  return (
    <div className="rounded-lg border border-[#e0e0e0] p-6">
      <div className="flex gap-4 pb-6 border-b border-[#e0e0e0]">
        <ProgressCircle value={score} color={getColor(score)} />
        <div className="space-y-1">
          <h3 className="font-medium text-[#1a1817]">{title}</h3>
          <p className="text-[#6b6866] text-sm">{description}</p>
        </div>
      </div>

      <div className="space-y-6 pt-6">
        <div>
          <h4 className="font-medium text-[#1a1817] mb-2">{t('feedback.assessment.why', 'Why')}</h4>
          <p className="text-[#6b6866]">{explanation}</p>
        </div>

        {improvement && (
          <div>
            <h4 className="font-medium text-[#1a1817] mb-2">{t('feedback.assessment.what_improve', 'What to improve')}</h4>
            <p className="text-[#6b6866]">{improvement}</p>
          </div>
        )}
      </div>
    </div>
  );
}
